import { render, staticRenderFns } from "./GraphDetail45.vue?vue&type=template&id=3b6f5b9c&scoped=true"
import script from "./GraphDetail45.vue?vue&type=script&lang=js"
export * from "./GraphDetail45.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6f5b9c",
  null
  
)

export default component.exports